/**
 * Which sidebar section an ended process conversation goes to.
 *
 * The server lists a process conversation while the process works in one of the viewer's lanes, and
 * keeps it once the process has ended in one of them, marked `processState: 'ended'`
 * (tri-server: processVisibilityFor). Ended ones get a section of their own; a conversation with an
 * open task for the viewer stays under "Prozesse" whatever the state says.
 */
export function isEndedProcessConversation(conv: any): boolean {
    if ((conv?.worklist?.length ?? 0) > 0) return false;
    return conv?.processState === 'ended';
}
